<template lang="html">
  <NuxtPicture
    format="avif,webp"
    legacyFormat="png"
    :src="src"
    :provider="provider"
    :alt="props.alt"
    :sizes="props.sizes"
    :loading="props.loading"
    :img-attrs="imgAttrs"
    :class="base"
  />
</template>

<script setup lang="ts">
export type UiPictureVariant = 'imageFull' | 'native' | 'heightFull'

const props = withDefaults(
  defineProps<{
    src?: string
    fallback?: string
    provider?: 'ipx' | 'skubyApi'
    variant?: UiPictureVariant
    /** Альтернативный текст (доступность + картиночный поиск) */
    alt?: string
    /**
     * Реальная ширина слота (атрибут sizes): без него NuxtPicture считает
     * картинку вьюпортной, и браузер качает вариант 640px+ даже для
     * карточки в 300px
     */
    sizes?: string
    /** 'lazy' для картинок ниже фолда — не конкурируют с LCP за сеть */
    loading?: 'lazy' | 'eager'
    /** 'high' только для LCP-кандидата (главный баннер, первый слайд PDP) */
    fetchpriority?: 'high' | 'low'
  }>(),
  {
    fallback: '/Plug.svg',
    provider: 'skubyApi',
    variant: 'native',
    alt: '',
  },
)

const src = computed(() => props.src || props.fallback)
const provider = computed(() => (props.src ? props.provider : 'ipx'))

// fetchpriority — не проп NuxtPicture, доносится до <img> через imgAttrs
const imgAttrs = computed(() =>
  props.fetchpriority ? { fetchpriority: props.fetchpriority } : undefined,
)

const base = computed(() => {
  const classes: string[] = []

  if (props.variant === 'imageFull')
    classes.push('[&>img]:w-full [&>img]:h-full [&>img]:object-cover')
  if (props.variant === 'heightFull')
    classes.push('[&>img]:h-full [&>img]:object-cover [&>img]:w-auto')

  return classes
})
</script>
